import { pow } from '../internal';
export var easeOutQuint = function (x) { return 1 - pow(1 - x, 5); };
